import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class UserCard extends Vue {
	@Prop({ type: String }) imageUrl;
	@Prop({ required: true, type: String }) name;
	@Prop({ required: true, type: String }) email;

	get nameInitial() {
		return this.name.charAt(0);
	}
}
